import type { HubConnection } from "@microsoft/signalr";

export let connection: HubConnection | null = null;
export let connecting = false;
export let startPromise: Promise<void> | null = null;

export const setConnection = (value: HubConnection | null) => {
  connection = value;
};

export const setConnecting = (value: boolean) => {
  connecting = value;
};

export const setStartPromise = (value: Promise<void> | null) => {
  startPromise = value;
};

export const log = (...args: unknown[]) => {
  if (process.env.NODE_ENV !== "production") {
    console.log("[SignalR]", ...args);
  }
};
